require("./myProfileEditShippingAddressSuccess.scss");

// @ vendor
const React = require("react");
const PropTypes = require("prop-types");

// @components
const WizardSuccess = require("components/commons/wizardSuccess/wizardSuccess");

// @commons
const { formatText, FormattedText } = require("core/i18n").i18n;
const OKInformativeList = require("components/rebrand/OKInformativeList/OKInformativeList");
const OKInformativeListItem = require("components/rebrand/OKInformativeListItem/OKInformativeListItem");

// @utilities
const PersonalDataHelper = require("utilities/personalDataHelper");
const { recordProcess } = require("utilities/tagging");
const { changeBiocatchContext } = require("utilities/biocatch");

//@constants
const {
    PROC_ADD_SHIPPING_ADDRESS,
    PROC_EDIT_SHIPPING_ADDRESS,
    PROC_END
} = require("utilities/tagging");
const biocatch = require("constants/biocatch");

class MyProfileEditShippingAddressSuccess extends React.Component {
    componentDidMount() {
        const { immProfileShippingAddress } = this.props;

        let processType = PROC_ADD_SHIPPING_ADDRESS;

        if (immProfileShippingAddress.get("hasShippingAddress")) {
            processType = PROC_EDIT_SHIPPING_ADDRESS;
        }
        recordProcess(processType, PROC_END);
    }

    render() {
        const { immHireContactData, immProfileShippingAddress } = this.props;
        const goBackButton = {
            label: (
                <FormattedText value="profileEditShippingAddress-profileEditShippingAddress_successBackButtonText" />
            ),
            url: `/myprofile/edit`
        };
        const newShippingAddressTitle = formatText(
            "profileEditShippingAddress-profileEditShippingAddress_newShippingAddress"
        );
        const formatedAddress = PersonalDataHelper.getHireFormattedAddress(
            immHireContactData
        );

        let successMessage =
            "profileEditShippingAddress-profileEditShippingAddress_modificationSuccess";

        if (!immProfileShippingAddress.get("hasShippingAddress")) {
            successMessage =
                "profileEditShippingAddress-profileEditShippingAddress_addSuccess";
        }

        changeBiocatchContext(biocatch.SUCCESSFUL_CHANGE);

        return (
            <WizardSuccess
                mainButton={goBackButton}
                successMessage={formatText(successMessage)}
            >
                <OKInformativeList columns={2}>
                    <OKInformativeListItem title={newShippingAddressTitle}>
                        <span className="profile-edit-shipping-address-success__detail">
                            {formatedAddress}
                        </span>
                    </OKInformativeListItem>
                </OKInformativeList>
            </WizardSuccess>
        );
    }
}

MyProfileEditShippingAddressSuccess.propTypes = {
    immHireContactData: PropTypes.object.isRequired,
    immProfileShippingAddress: PropTypes.object.isRequired
};

module.exports = MyProfileEditShippingAddressSuccess;
